module.exports = __webpack_public_path__ + "static/media/logo.1653c647.svg";